import React from "react";
import { Grid, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { TextField } from "icw-components/InputFields";
import T from "i18n-react";

const LoginForm = props => {
    const { values, errors, touched, handleChange, handleBlur, setFieldTouched } = props;

    return (
        <>
            <Box display="flex" justifyContent="flex-start" pt={4} pb={2}>
                <Box fontSize="16px" fontWeight="bold" color="#232B3A">
                    {T.translate("iSource.login")}
                </Box>
            </Box>
            <Grid container justify="flex-start" spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("general.email")}
                    </Box>
                    <TextField
                        name="loginEmail"
                        variant="outlined"
                        fullWidth
                        noLabel
                        placeholder={T.translate("iSource.placeholder.loginTitle")}
                        value={values.loginEmail}
                        error={!!(touched.loginEmail && errors.loginEmail)}
                        setFieldTouched={setFieldTouched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    <Box fontSize="12px" fontWeight="500" color="red">
                        {touched.loginEmail && errors.loginEmail}
                    </Box>
                    <Box fontSize="12px" fontWeight="400">
                        {T.translate("general.password")}
                    </Box>
                    <TextField
                        name="password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        noLabel
                        placeholder={T.translate("iSource.placeholder.password")}
                        value={values.password}
                        error={!!(touched.password && errors.password)}
                        setFieldTouched={setFieldTouched}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    <Box fontSize="12px" fontWeight="500" color="red">
                        {touched.password && errors.password}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};

LoginForm.propTypes = {
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldTouched: PropTypes.func,
};

export default LoginForm;
